// mutations_type 雖然是非必要的檔案，主要作為
// action 與 mutation 中間溝通的對應表，這隻檔案的存在，
// 是當系統成長到一定的程度，防止 mutation key 重複，造成不可預期情況發生，也有防呆作用 。

//export 關鍵字，外界才能存取

export const RECODE_TOKEN = 'RECODE_TOKEN';
export const LOGOUT = 'LOGOUT';
export const RECODE_MEMBERINFO = 'RECODE_MEMBERINFO';

export const FORGETPWD = 'FORGETPWD';


/** Log */
export const RECODE_HISTORYLOG = 'RECODE_HISTORYLOG';
export const PUSH_HISTORYLOG = 'PUSH_HISTORYLOG';

export const RECODE_USELOG = 'RECODE_USELOG';
export const PUSH_USELOG = 'PUSH_USELOG';
export const RECODE_PAYMENTLOG = 'RECODE_PAYMENTLOG';
export const PUSH_PAYMENTLOG = 'PUSH_PAYMENTLOG';

/** Ana */
export const RECODE_ANARESULT = 'RECODE_ANARESULT';
export const RECODE_ANASUBRESULT = 'RECODE_ANASUBRESULT';

/** Prodata */
export const RECODE_PRODUCTDATA = 'RECODE_PRODUCTDATA';

/** Daily */
export const RECODE_DAILYDATA = 'RECODE_DAILYDATA';

/** Point */
export const RECODE_POINT = 'RECODE_POINT';

/** Recode shopcart */
export const RECODE_SHOPCART = 'RECODE_SHOPCART';
/** Recode order */
export const RECODE_ORDERPURCHASE = 'RECODE_ORDERPURCHASE';
/** Recode plan */
export const RECODE_PLAN = 'RECODE_PLAN';
/** Master Tips */
export const RECODE_MASTERTIPS = 'RECODE_MASTERTIPS';
/** Updata Profile */
export const UPDATA_PROFILE = 'UPDATA_PROFILE';

